import { parseISO } from "date-fns";
import { z } from "zod";

export const MAX_GESTATIONAL_AGE_WEEKS = 45;

const parseDate = (value: unknown) => {
  if (!value) return undefined;
  if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
  const parsed = parseISO(value as string);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
};

export const pregnancyCloseoutFormSchema = z.object({
  closeoutDate: z.preprocess(
    parseDate,
    z.date({
      required_error: "Close out date is required",
      invalid_type_error: "Enter a valid close out date",
    }),
  ),
  outcome: z
    .object({
      system: z.string(),
      code: z.string(),
      display: z.string(),
    })
    .refine((outcome) => outcome.system && outcome.code && outcome.display, {
      message: "Outcome is required",
    }),
  gestationalAge: z.number().min(0, "GA must be 0 or greater").optional(),
  notes: z.string().trim().optional(),
});

export type PregnancyCloseoutFormValues = z.infer<typeof pregnancyCloseoutFormSchema>;
